import {
  UnorderedListOutlined,
  UserAddOutlined,
  TeamOutlined,
  LogoutOutlined,
  PhoneOutlined,
  InboxOutlined,
  CalendarOutlined,
  SettingOutlined,
  PieChartOutlined
} from "@ant-design/icons";
import { Alert, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import styles from "./Panel.module.css";
import * as actions from "../../store/actions/action";
import Logo from "../../Components/Logo/Logo";

const { Content, Footer, Sider } = Layout;

function getItem(label, key, icon, children, onClick, className) {
  return {
    key,
    icon,
    children,
    label,
    onClick,
    className
  };
}


const Panel = ({ error, ClearError, Logout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(null);
  const items = [
    getItem("ثبت‌ نام", "SignUp", <UserAddOutlined />, [
      getItem("درخواست‌ها", "Requests", <InboxOutlined />, null, () => { navigate('/Requests') }),
      getItem("پیگیری", "TrackingList", <PhoneOutlined />, null, () => { navigate('/TrackingList') })]),
    // getItem("تعیین کلاس", "ClassSelection", <CalendarOutlined />, null, () => { navigate('/ClassSelection') }),
    // getItem("لیست رزرو", "ReservedList", <UnorderedListOutlined />, null, () => { navigate('/ReservedList') }),
    getItem("زبان آموزان", "Learners", <TeamOutlined />, null, () => { navigate('/Learners') }),
    getItem("گزارش", "Report", <PieChartOutlined />, null, () => { navigate('/Report') }),
    getItem("تنظیمات", "Settings", <SettingOutlined />, null, () => { navigate('/Settings') }),
    getItem("خروج", "Logout", <LogoutOutlined />, null, () => {
      Logout();
      navigate('/Login')
    }, styles.MenuItemDanger),
  ];
  useEffect(() => {
    if (error) {
      setTimeout(() => {
        ClearError();
        console.log('Error Cleared')

      }, 6000)
    }



  }, [error])
  useEffect(() => {
    if (location.pathname === '/') {
      navigate('/Learners')
    }

  }, [location.pathname, navigate])
  useEffect(() => {
    if (location.pathname === '/Learners') {
      setActiveKey('Learners')
    }
    else if (location.pathname === '/Requests') {
      setActiveKey('Requests')

    }
    else if (location.pathname === '/TrackingList') {
      setActiveKey('TrackingList')

    }
    else if (location.pathname === '/ReservedList') {
      setActiveKey('ReservedList')

    }
    else if (location.pathname === '/Settings') {
      setActiveKey('Settings')

    }
    else if (location.pathname === '/Report') {
      setActiveKey('Report')

    }
  }, [location.pathname])
  const [collapsed, setCollapsed] = useState(false);
  const theme =  'light';

  return (
    <Layout
      style={{
        minHeight: "100vh",

      }}
    >
      <Sider
        theme={theme}
        collapsible
        collapsed={collapsed}
        className={styles.Slider}
        onCollapse={(value) => setCollapsed(value)}
      >
        <Link to='/Requests' className={[styles.Logo, theme === 'dark' ? styles.DarkMode : null].join(' ')}>
          <Logo />
        </Link>
        <Menu
          theme={theme}
          selectedKeys={[activeKey]}
          mode="inline"
          items={items}
        />

      </Sider>
      <Layout className={styles.Layout}>

        <Content className={styles.Content}>
          <Outlet />
          {error ? <div className={styles.ErrorMessageContainer}><Alert type="error" className={styles.ErrorMessage} afterClose={ClearError} showIcon closable description={error} message='خطا' /> </div> : null}
        </Content>
        <Footer
          style={{
            textAlign: "center",
          }}
        >
          Developed By Bracket
        </Footer>
      </Layout>
    </Layout>
  )
}
const mapStateToProps = (state) => {
  return {
    error: state.error
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ErrorSetter: (error, errorType) => dispatch(actions.ErrorSetter(error, errorType)),
    ClearError: () => dispatch(actions.ClearError()),
    LoadingSetter: (error, errorType) => dispatch(actions.LoadingSetter()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    Logout: () => dispatch(actions.Logout()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Panel);
